/**
 * PSN Subscription Table Simple Sticky Behavior
 * Only handles header height changes for sticky positioning
 */

class PSNSubscriptionTable {
  constructor() {
    this.init();
  }

  init() {
    // Only run on mobile devices
    if (window.innerWidth > 990) return;

    this.bindEvents();
    this.updateHeaderHeight();
  }

  updateHeaderHeight() {
    // Simple logic: set CSS custom property based on body class
    const isScrolledDown = document.body.classList.contains('scroll-down');
    const headerHeight = isScrolledDown ? 108 : 145;
    const tableHeaderHeight = 56;
    const totalHeaderHeight = headerHeight + tableHeaderHeight;
    
    // Set CSS custom properties for the table container
    const tableContainer = document.querySelector('[data-subscription-table]');
    if (tableContainer) {
      document.documentElement.style.setProperty('--sticky-header-top', `${headerHeight}px`);
      document.documentElement.style.setProperty('--sticky-delivery-top', `${totalHeaderHeight}px`);
    }
  }

  bindEvents() {
    // Only track body class changes for header state
    this.bodyClassObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          this.updateHeaderHeight();
        }
      });
    });

    this.bodyClassObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Simple resize handler
    this.resizeHandler = () => {
      if (window.innerWidth > 990) {
        this.destroy();
      }
    };

    window.addEventListener('resize', this.resizeHandler);
  }

  destroy() {
    // Disconnect body class observer
    if (this.bodyClassObserver) {
      this.bodyClassObserver.disconnect();
      this.bodyClassObserver = null;
    }

    // Remove resize listener
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
      this.resizeHandler = null;
    }

    // Reset CSS custom properties
    document.documentElement.style.removeProperty('--sticky-header-top');
    document.documentElement.style.removeProperty('--sticky-delivery-top');
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new PSNSubscriptionTable();
});

// Also initialize if script loads after DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new PSNSubscriptionTable();
  });
} else {
  new PSNSubscriptionTable();
}

const stickyEl = document.querySelector('.psn-subscription-table-head');

// Exit early if the sticky element doesn't exist on this page
if (!stickyEl) {
  console.log('PSN Subscription Table: .psn-subscription-table-head not found on this page');
} else {
  function getStickyOffset() {
    if (!stickyEl) return 0;
    return parseInt(getComputedStyle(stickyEl).top, 10) || 0;
  }

  let stickyOffset = getStickyOffset();

  function checkSticky() {
    if (!stickyEl) return;
    
    if (stickyEl.getBoundingClientRect().top <= stickyOffset) {
      stickyEl.classList.add('is-sticky');
    } else {
      stickyEl.classList.remove('is-sticky');
    }
  }

  // run initially
  checkSticky();

  // update on scroll
  window.addEventListener('scroll', checkSticky, { passive: true });

  // update sticky offset on resize
  window.addEventListener('resize', () => {
    stickyOffset = getStickyOffset();
    checkSticky();
  });
  window.addEventListener('orientationchange', () => {
    stickyOffset = getStickyOffset();
    checkSticky();
  });
}

export default PSNSubscriptionTable;
